import {Reducer} from 'redux'
import {RolesActionTypes, RolesState} from './types';
import RolesService from "../../services/RolesService";

const initialState: RolesState = {
	list: []
}

const reducer: Reducer<RolesState> = (state = initialState, action) => {
	switch (action.type) {
		case RolesActionTypes.FETCH_ALL_REQUEST: {
			RolesService.getAll()
			return { ...state, loading: true }
		}
		case RolesActionTypes.FETCH_ALL_COMPLETED: {
			return { ...state, loading: false, list: action.payload}
		}
		case RolesActionTypes.FETCH_ONE_REQUEST: {
			RolesService.getOne(action.payload)
			return { ...state, loading: true }
		}
		case RolesActionTypes.FETCH_ONE_COMPLETED: {
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1, action.payload)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case RolesActionTypes.SAVE_REQUEST: {
			RolesService.save(action.payload)
			return { ...state, loading: true }
		}
		case RolesActionTypes.SAVE_COMPLETED: {
			let newRole = action.payload
			let foundIndex = state.list.findIndex(element => element.id === newRole.id)
			state.list.splice(foundIndex, 1, action.payload)
			let newList = [...state.list]
			return { ...state, list: newList}
		}
		case RolesActionTypes.DELETE_REQUEST: {
			RolesService.delete(action.payload)
			return { ...state, loading: true }
		}
		case RolesActionTypes.DELETE_COMPLETED: {
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case RolesActionTypes.DELETE_MULTIPLE_REQUEST: {
			RolesService.deleteRoles(action.payload)
			return { ...state, loading: true }
		}
		case RolesActionTypes.DELETE_MULTIPLE_COMPLETED: {
			action.payload.forEach((item: any) => {
				let foundIndex = state.list.findIndex(element => element.id === item.id)
				state.list.splice(foundIndex, 1)
			});
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		default: {
			return state
		}
	}
}

export {reducer as RolesReducer}